module.exports = __webpack_public_path__ + "static/media/logo-negativo.31c64578.png";